import React, { useState, useEffect, useCallback } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FiLogOut } from "react-icons/fi";
import logo from "../src/Logo.png";
import { AUTH_API_BASE } from "./config/api";

export default function ItemTable({ currentUser }) {

const API_BASE = AUTH_API_BASE;

const isViewer = currentUser?.role === "viewer";

const canEdit =
currentUser?.permissions?.edit === true ||
currentUser?.role === "itemadmin";

const gridColumns = "60px 1.5fr 1fr 1fr 2fr 160px";

const [suggestions, setSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);

const [showTable, setShowTable] = useState(!isViewer);

const [form, setForm] = useState({
itemName: "",
unit: "PCS",
price: "",
remarks: "",
});

const [items, setItems] = useState([]);
const [editIndex, setEditIndex] = useState(null);

const [selectedDate, setSelectedDate] = useState(
new Date().toISOString().split("T")[0]
);

const searchItems = async (value) => {

if (!value) {
setSuggestions([]);
return;
}

try {

const res = await fetch(`${API_BASE}/items/search?term=${value}`);
const data = await res.json();

setSuggestions(Array.isArray(data) ? data : []);
setShowSuggestions(true);

} catch (err) {

console.error("Search error:", err);

}

};

const fetchItems = useCallback(async () => {

try {

const res = await fetch(`${API_BASE}/itempricing`);
const data = await res.json();

setItems(Array.isArray(data) ? data : []);

} catch (err) {

console.error("Error fetching items:", err);
setItems([]);

}

}, [API_BASE]);

useEffect(() => {

fetchItems();

}, [fetchItems]);

const handleAddOrUpdate = async () => {

if (!form.itemName.trim()) {
alert("Item Name is required");
return;
}

try {

if (editIndex !== null) {

const id = items[editIndex].Id;

await fetch(`${API_BASE}/itempricing/${id}`, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify(form),
});

} else {

await fetch(`${API_BASE}/itempricing`, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify(form),
});

}

setForm({ itemName: "", unit: "PCS", price: "", remarks: "" });
setEditIndex(null);

fetchItems();

} catch (err) {

console.error("Error saving item:", err);

}

};

const handleEdit = (index) => {

const item = items[index];

setForm({
itemName: item.ItemName,
unit: item.Unit,
price: item.Price,
remarks: item.Remarks,
});

setEditIndex(index);

};

const downloadExcel = () => {

if (!items || items.length === 0) {
alert("No data available to download");
return;
}

const excelData = items.map((item, index) => ({
"S.No": index + 1,
"Item Name": item.ItemName || "",
"Unit": item.Unit || "",
"Price": item.Price || "",
"Remarks": item.Remarks || "",
}));

const worksheet = XLSX.utils.json_to_sheet(excelData);
const workbook = XLSX.utils.book_new();

XLSX.utils.book_append_sheet(workbook, worksheet, "Items");

const excelBuffer = XLSX.write(workbook, {
bookType: "xlsx",
type: "array",
});

const data = new Blob([excelBuffer], {
type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
});

saveAs(data, "items_list.xlsx");

};

const handleLogout = () => {

localStorage.removeItem("currentUser");
window.location.href = "/";

};

return (

<div style={styles.page}>

<div style={styles.header}>

<div style={styles.headerLeft}>
<img src={logo} alt="logo" style={styles.logo} />
<h2 style={styles.title}>Item Pricing</h2>
</div>

<div style={styles.headerRight}>

<input
type="date"
value={selectedDate}
onChange={(e) => setSelectedDate(e.target.value)}
style={styles.dateInput}
/>

<button
style={styles.downloadBtn}
onClick={() => {

if (isViewer && !showTable) {
setShowTable(true);
return;
}

downloadExcel();

}}
>
{isViewer && !showTable ? "Show Items" : "Download Excel"}
</button>

<FiLogOut
style={styles.logout}
onClick={handleLogout}
title="Logout"
/>

</div>

</div>

<div style={styles.mainLayout}>

{!isViewer && (

<div style={styles.formCard}>

<h3 style={styles.cardTitle}>Item Entry</h3>

{[
{ label: "Item Name", key: "itemName" },
{ label: "Unit", key: "unit" },
{ label: "Price", key: "price" },
{ label: "Remarks", key: "remarks" },
].map(({ label, key }) => (

<div key={key} style={styles.inputGroup}>

<label style={styles.label}>{label}</label>

{key === "unit" ? (

<select
style={styles.input}
value={form.unit}
onChange={(e) =>
setForm((prev) => ({
...prev,
unit: e.target.value,
}))
}
disabled={!canEdit}
>

<option value="PCS">PCS</option>
<option value="KG">KG</option>
<option value="BOX">BOX</option>
<option value="PKT">PKT</option>

</select>

) : (

<input
style={styles.input}
value={form[key]}
onChange={(e) => {

const value = e.target.value.toUpperCase();

setForm((prev) => ({
...prev,
[key]: value,
}));

if (key === "itemName") {
searchItems(value);
}

}}
disabled={!canEdit}
/>

)}

{key === "itemName" &&
showSuggestions &&
Array.isArray(suggestions) &&
suggestions.length > 0 && (

<div style={styles.suggestionBox}>

{suggestions.map((item, i) => (

<div
key={i}
style={styles.suggestionItem}
onClick={() => {

setForm((prev) => ({
...prev,
itemName: item.DESCRIPTION,
}));

setShowSuggestions(false);

}}
>

{item.DESCRIPTION}

</div>

))}

</div>

)}

</div>

))}

{canEdit && (

<button
style={styles.primaryBtn}
onClick={handleAddOrUpdate}
>
{editIndex !== null ? "Update Item" : "Add Item"}
</button>

)}

</div>

)}

{showTable && (

<div style={styles.tableCard}>

<div style={{ ...styles.gridHeaderRow, gridTemplateColumns: gridColumns }}>

{["S.No", "Item Name", "Unit", "Price", "Remarks", "Action"].map((h, i) => (
<div key={i}>{h}</div>
))}

</div>

<div style={styles.tableBody}>

{!Array.isArray(items) || items.length === 0 ? (

<div style={styles.noData}>No items available</div>

) : (

items.map((item, index) => (

<div
key={index}
style={{
...(index % 2 === 0 ? styles.gridRowEven : styles.gridRowOdd),
gridTemplateColumns: gridColumns,
}}
>

<div>{index + 1}</div>
<div>{item.ItemName}</div>
<div>{item.Unit}</div>
<div>{item.Price}</div>
<div>{item.Remarks}</div>

<div>

{canEdit ? (

<>

<button
style={styles.updateBtn}
onClick={() => handleEdit(index)}
>
Update
</button>

<button
style={styles.deleteBtn}
onClick={async () => {

if (!window.confirm("Delete item?")) return;

await fetch(`${API_BASE}/itempricing/delete/${item.Id}`, {
method: "POST",
});

fetchItems();

}}
>
Delete
</button>

</>

) : (

<span style={{ color: "#94a3b8" }}>No Access</span>

)}

</div>

</div>

))

)}

</div>

</div>

)}

</div>

</div>

);

}

const styles = {

page:{
background:"#f1f5f9",
minHeight:"100vh",
padding:"30px",
fontFamily:"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
color:"#1f2937"
},

header:{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:"25px"
},

headerLeft:{
display:"flex",
alignItems:"center",
gap:"12px"
},

logo:{
height:"42px"
},

title:{
fontSize:"22px",
fontWeight:"600",
letterSpacing:"0.3px",
color:"#0f172a"
},

headerRight:{
display:"flex",
alignItems:"center",
gap:"12px"
},

logout:{
fontSize:"24px",
color:"#ef4444",
cursor:"pointer"
},

mainLayout:{
display:"flex",
gap:"25px"
},

formCard:{
flex:"1",
background:"#fff",
padding:"25px",
borderRadius:"12px",
boxShadow:"0 6px 18px rgba(0,0,0,0.08)"
},

tableCard:{
flex:"2",
background:"#fff",
padding:"20px",
borderRadius:"12px",
boxShadow:"0 6px 18px rgba(0,0,0,0.08)"
},

cardTitle:{
marginBottom:"18px",
fontWeight:"600",
fontSize:"16px",
color:"#111827",
letterSpacing:"0.3px"
},

inputGroup:{
marginBottom:"15px",
display:"flex",
flexDirection:"column"
},

label:{
fontSize:"12px",
marginBottom:"6px",
color:"#64748b",
fontWeight:"500",
letterSpacing:"0.3px"
},

input:{
padding:"10px 12px",
borderRadius:"6px",
border:"1px solid #d1d5db",
fontSize:"14px",
color:"#111827",
outline:"none",
background:"#ffffff",
transition:"all 0.2s ease"
},

primaryBtn:{
marginTop:"10px",
padding:"12px",
background:"#2563eb",
color:"#fff",
border:"none",
borderRadius:"6px",
cursor:"pointer",
fontWeight:"600"
},

gridHeaderRow:{
display:"grid",
padding:"12px",
background:"#1e293b",
color:"#fff",
borderRadius:"8px",
fontWeight:"500",
fontSize:"13px",
letterSpacing:"0.3px"
},

gridRowEven:{
display:"grid",
padding:"12px",
background:"#f8fafc",
marginTop:"6px",
borderRadius:"6px"
},

gridRowOdd:{
display:"grid",
padding:"12px",
background:"#fff",
marginTop:"6px",
borderRadius:"6px"
},

tableBody:{
marginTop:"10px"
},

updateBtn:{
background:"#2563eb",
color:"#fff",
border:"none",
padding:"6px 10px",
borderRadius:"5px",
marginRight:"5px",
cursor:"pointer"
},

deleteBtn:{
background:"#dc2626",
color:"#fff",
border:"none",
padding:"6px 10px",
borderRadius:"5px",
cursor:"pointer"
},

downloadBtn:{
background:"#16a34a",
color:"#fff",
border:"none",
padding:"8px 14px",
borderRadius:"6px",
cursor:"pointer"
},

dateInput:{
padding:"6px",
borderRadius:"6px",
border:"1px solid #cbd5e1"
},

suggestionBox:{
border:"1px solid #cbd5e1",
borderRadius:"6px",
marginTop:"4px",
background:"#fff",
maxHeight:"150px",
overflowY:"auto"
},

suggestionItem:{
padding:"8px",
cursor:"pointer"
},

noData:{
textAlign:"center",
padding:"20px",
color:"#64748b"
}

};
